export const Fonts = [
    'Arial',
    'Brush Script MT',
    'Courier New',
    'Garamond',
    'Georgia',
    'Tahoma',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana'
]